exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".o-OrderRow {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.o-OrderRow-row {\r\n    display: flex;\r\n\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.o-OrderRow-column {\r\n    flex: 1 1 auto;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/orderRow.css
// module id = 80
// module chunks = 3